<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <!-- Filters -->
    <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters
          :alarm-filter.sync="alarmFilter"
          :alarm-options="alarmOptions"
          :type-alarm-filter.sync="typeAlarmFilter"
          :type-alarm-options="typeAlarmOptions"
          :region-filter.sync="regionFilter"
          :region-options="regionOptions"
          :municipality-filter.sync="municipalityFilter"
          :municipality-options="municipalityOptions"
          :created-at-filter.sync="createdAtFilter"
          :updated-at-filter.sync="updatedAtFilter"
          :all-downloaded-at-filter.sync="allDownloadedAtFilter"
          :all-sent-at-filter.sync="allSentAtFilter"
        />
      </template>
    </filter-modal>

    <b-card class="m-2" no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize">{{ $t("table.entries") }}</label>
          </b-col>
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end seproban-search-actions">
              <faceted-search
                :options="searchOptions"
                class="mr-1 seproban-search-input"
                @search="setFacetedFilters"
              />
              <b-button
                @click="exportExcel()"
                variant="success"
                class="text-capitalize ml-1"
                type="button"
                :disabled="buttonExport"
              >
                <feather-icon icon="DownloadCloudIcon" size="15" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 1) }}</span>
        </template>
        <template #head(id_alarm)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
        <template #head(total_snapshots)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
        <template #head(created_at)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
        <template #head(updated_at)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
        <template #head(is_send)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>
        <template #head(sent_at)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #cell(actions)="data">
          <b-button
            :id="`actions-${data.item.id}`"
            tabindex="0"
            variant="white"
            class="px-1 btn-y"
          >
            <feather-icon
              data-cy="actions"
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </b-button>
          <b-popover
            :target="`actions-${data.item.id}`"
            triggers="focus"
            placement="bottom"
            custom-class="popover-p-0"
            variant="white"
          >
            <b-list-group class="m-0">
              <b-list-group-item
                @click="seprobanImages(data.item.id)"
                v-if="$can('read', 'SeprobanRequest')"
                class="border-0"
                button
              >
                <feather-icon icon="FileIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("seproban.images") }}
                </span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
              $t("table.showing", {
                from: dataMeta.from,
                to: dataMeta.to,
                of: dataMeta.of,
              })
            }}</span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import router from "@/router";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Pagination from "@/components/Pagination.vue";
import ImageModal from "../../components/GridView/widgets/ImageModal.vue";
import Filters from "./Filters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BImg,
    vSelect,
    Pagination,
    ImageModal,
    Filters,
    FilterModal,
    ButtonFilters,
    FacetedSearch,
  },

  setup(_, context) {
    const searchOptions = [
      { label: "Nombre", value: "description", isArray: false },
      { label: "REMS", value: "rems", isArray: false },
      { label: "SIRH", value: "sirh", isArray: false },
    ];

    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const exportExcel = () => {
      action.value = "export";
      fetchList();
    };

    const buttonExport = ref(false);
    const { t } = useI18nUtils();
    const toast = useToast();
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      action,
      buildFilters,
      filtersCount,
      alarmOptions,
      alarmFilter,
      typeAlarmOptions,
      typeAlarmFilter,
      regionOptions,
      regionFilter,
      municipalityOptions,
      municipalityFilter,
      createdAtFilter,
      updatedAtFilter,
      allDownloadedAtFilter,
      allSentAtFilter,
      clearSearchFilters,
      setFacetedFilters,
    } = useList();

    const seprobanImages = function (id) {
      router.push({ path: `/seproban/images/${id}` });
    };

    return {
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      buttonExport,
      alarmOptions,
      alarmFilter,
      typeAlarmOptions,
      typeAlarmFilter,
      regionOptions,
      regionFilter,
      municipalityOptions,
      municipalityFilter,
      createdAtFilter,
      updatedAtFilter,
      allDownloadedAtFilter,
      allSentAtFilter,
      filtersCount,

      update,
      exportExcel,
      fetchList,
      buildFilters,
      refetchData,
      formatDateAssigned,
      clearSearchFilters,
      seprobanImages,
      searchOptions,
      setFacetedFilters,
    };
  },
};
</script>

<style scoped lang="scss">
.seproban-search-input {
  flex: 1 1 0;
  min-width: 280px;
}

@media (max-width: 767.98px) {
  .seproban-search-actions {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .seproban-search-input {
    min-width: 100%;
    margin-right: 0 !important;
  }
}
</style>


